import { render, staticRenderFns } from "./tech-topbar.vue?vue&type=template&id=ef134dba&scoped=true"
import script from "./tech-topbar.vue?vue&type=script&lang=ts"
export * from "./tech-topbar.vue?vue&type=script&lang=ts"
import style0 from "./tech-topbar.vue?vue&type=style&index=0&id=ef134dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef134dba",
  null
  
)

export default component.exports